let notificationAudio = null;

const getNotificationAudio = () => {
    if (!notificationAudio) {
        notificationAudio = new Audio(
            `${process.env.PUBLIC_URL || ""}/sounds/notify.wav`
        );

        notificationAudio.preload = "auto";
        notificationAudio.volume = 1.0;
    }

    return notificationAudio;
};

export const unlockNotificationSound = async () => {
    try {
        const audio = getNotificationAudio();

        audio.muted = true;
        audio.currentTime = 0;

        await audio.play();

        audio.pause();
        audio.currentTime = 0;
        audio.muted = false;

        return true;
    } catch (error) {
        console.debug(
            "Notification audio unlock failed:",
            error
        );

        return false;
    }
};

export const stopNotificationSound = () => {
    try {
        if (!notificationAudio) return;

        notificationAudio.pause();
        notificationAudio.currentTime = 0;
    } catch {
        // Ignore
    }
};

export const playNotificationSound = async () => {
    try {
        const audio = getNotificationAudio();

        audio.currentTime = 0;

        await audio.play();
    } catch (error) {
        console.debug(
            "Notification sound failed:",
            error
        );
    }
};